/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { DocumentStore, DocumentStoreInterface } from "../DocumentStore";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "initAdmin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessControlBadConfirmation",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "neededRole",
        type: "bytes32",
      },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentExists",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentIsRevoked",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentNotIssued",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "InactiveDocument",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "InvalidDocument",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroDocument",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroOwner",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentIssued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ISSUER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REVOKER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "isActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
    ],
    name: "isActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
    ],
    name: "isIssued",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "isIssued",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
    ],
    name: "isRevoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "isRevoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
    ],
    name: "issue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "callerConfirmation",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "revoke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
    ],
    name: "revoke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type DocumentStoreConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DocumentStoreConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DocumentStore__factory extends ContractFactory {
  constructor(...args: DocumentStoreConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    name: string,
    initAdmin: string,
    overrides?: Overrides & { from?: string }
  ): Promise<DocumentStore> {
    return super.deploy(
      name,
      initAdmin,
      overrides || {}
    ) as Promise<DocumentStore>;
  }
  override getDeployTransaction(
    name: string,
    initAdmin: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(name, initAdmin, overrides || {});
  }
  override attach(address: string): DocumentStore {
    return super.attach(address) as DocumentStore;
  }
  override connect(signer: Signer): DocumentStore__factory {
    return super.connect(signer) as DocumentStore__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DocumentStoreInterface {
    return new utils.Interface(_abi) as DocumentStoreInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DocumentStore {
    return new Contract(address, _abi, signerOrProvider) as DocumentStore;
  }
}
